import styled from "styled-components";
import {
  Card,
  Typography,
  Button,
  CardContent,
  Select,
  FormControl,
  Container,
  Paper,
  Dialog,
  DialogTitle,
  IconButton,
  Tabs,
  TextField,
} from "@mui/material";
import { motion } from "framer-motion";

export const CalendarPageWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  // height: calc(100vh - 64px);
  position: relative;
  // overflow-x: auto;
  // overflow-y: hidden;
  overflow: hidden;
  &::-webkit-scrollbar {
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(99, 96, 150, 0.7);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const CalendarWrapper = styled(motion.div)`
  flex: ${(props) => (props.$isSidebarOpen ? "0 0 50%" : "1 0 100%")};
  min-width: ${(props) => (props.$isSidebarOpen ? "600px" : "auto")};
  height: 100%;
  transition: flex 0.3s ease;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

export const CalendarContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const CalendarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 48px;
  flex: 0 0 auto;
`;

export const DaysHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  padding: 8px 0;
  border-bottom: 1px solid #e2e8f0;
  flex: 0 0 auto;
`;

export const DatesGrid = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(6, 1fr);
  gap: 1px;
  background-color: #e2e8f0;
  border: 1px solid #e2e8f0;
  min-height: 0;
  overflow: hidden;
  max-height: 61vh;
`;

export const DateCell = styled.div`
  background-color: white;
  padding: 4px 8px;
  height: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  &.grayed {
    background-color: #f7fafc;
    color: #a0aec0;
  }
  &.grayed.sunday {
    .date-number {
      color: #e53e3e;
      opacity: 0.7;
    }
  }
  &.grayed.saturday {
    .date-number {
      color: #3182ce;
      opacity: 0.7;
    }
  }
  &.selected {
    border: 2px solid #4299e1;
  }
  &.sunday {
    .date-number {
      color: #e53e3e;
    }
  }
  &.saturday {
    .date-number {
      color: #3182ce;
    }
  }
`;

export const Sidebar = styled(motion.aside)`
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  background-color: white;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  border-left: 1px solid #e9ecef;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: #333;
  }
`;

export const SelectedDateText = styled.h2`
  font-size: 1.25rem;
  margin: 0;
  color: #333;
`;

export const DateCellContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  min-height: 0;
`;

export const DateHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  padding: 2px 4px;
`;

export const DateNumber = styled.div`
  font-size: 0.875rem;
  margin-left: auto;
`;

export const ScheduleCount = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  .tooltip {
    visibility: hidden;
    position: absolute;
    left: ${(props) => (props.$isSidebarOpen ? "0px" : "24px")};
    top: ${(props) => (props.$isSidebarOpen ? "0px" : "2px")};
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 4px 4px;
    border-radius: 4px;
    font-size: 0.65rem;
    white-space: nowrap;
    z-index: 10;
    pointer-events: none;
  }
  &:hover .tooltip {
    visibility: visible;
  }
`;

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 2px;
  overflow: hidden;
  margin-top: auto;
`;

export const MachineTimeBox = styled.div`
  font-size: 0.7rem;
  padding: 1px 4px;
  margin: 0;
  background-color: #e3f2fd;
  border-radius: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  box-sizing: border-box;
`;

export const SpecTimeBox = styled.div`
  font-size: 0.7rem;
  padding: 1px 4px;
  margin: 0;
  background-color: #f5f5f5;
  border-radius: 2px;
  color: ${(props) => props.$isHoliday && "#e53e3e"};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InfoCard = styled.div`
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const MachineTitle = styled.div`
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 0.5rem;
`;

export const PresetInfo = styled.div`
  font-size: 0.875rem;
  color: #4a5568;
`;

export const DateInfo = styled.div`
  background-color: ${(props) => (props.$isHoliday ? "#fee2e2" : "#f8fafc")};
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid ${(props) => (props.$isHoliday ? "#fecaca" : "#e2e8f0")};
`;

export const SectionsWrapper = styled.div`
  height: calc(100% - 80px);
  overflow-y: auto;
  padding-right: 10px;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(99, 96, 150, 0.7);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const ActionButton = styled(Button)`
  margin-top: 1rem !important;
  width: 100%;
  justify-content: flex-start !important;
  text-transform: none !important;
  padding: 0.8rem 1rem !important;
`;

export const SectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e2e8f0;
  margin-bottom: 1rem;
  h3 {
    font-size: 1rem;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0;
  }
`;

export const HeaderButton = styled.button`
  border: none;
  background: none;
  font-size: 1.6rem;
  font-weight: 500;
  cursor: pointer;
`;

export const DayInfo = styled(DateInfo)`
  margin-top: 1rem;
`;

export const TimeSlots = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); // 한 줄에 2개씩 배치
  gap: 0.5rem;
  margin-top: 0.75rem;
`;

export const TimeSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f4f6;
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  transition: all 0.2s ease;

  &:hover {
    background-color: #e5e7eb;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
`;

export const TimeDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #4b5563;
  font-size: 0.9rem;
  font-weight: 500;

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    background-color: #6366f1;
    border-radius: 50%;
    margin-right: 4px;
  }
`;

export const ContainerMchSch = styled(Container)`
  padding: 1rem 0;
`;

export const TitleMchSch = styled(Typography)`
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 1.5rem;
`;

export const GridContainerMchSch = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  padding: 1rem;
  max-height: 62vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(99, 96, 150, 0.7);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  @media (max-width: 1400px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledCardMchSch = styled(Card)`
  transition: all 0.3s ease-in-out;
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const CardHeaderMchSch = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid #eee;
`;

export const CardTitleMchSch = styled(Typography)`
  font-weight: 500;
`;

export const ScheduleFormMchSch = styled.form`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  flex-direction: column;
  border-top: 1px solid #eee;
  padding-top: 1rem;
`;

export const StyledSelectMchSch = styled(Select)`
  flex: 1;
`;

export const ExpandableContentMchSch = styled(CardContent)`
  max-height: ${(props) => (props.$expanded ? "none" : "0")};
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  padding: ${(props) => (props.$expanded ? "16px" : "0")};
  visibility: ${(props) => (props.$expanded ? "visible" : "hidden")};
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FormRowMchSch = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const NoScheduleMessageMchSch = styled.div`
  color: #666;
  font-size: 0.875rem;
  text-align: center;
  padding: 0.5rem 1rem;
`;

export const ScheduleSummaryContainerMchSch = styled.div`
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ScheduleBoxMchSch = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  color: #333;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 0.5rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const PageWrapperFacH = styled(Container)`
  padding: 1rem 0;
  height: ${(props) => (props.$isModal ? "calc(100vh - 200px)" : "auto")};
`;

export const HeaderFacH = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => (props.$isModal ? "1rem" : "2rem")};
  .date-settings-container {
    width: 40%;
    display: flex;
    align-items: center;
    gap: 1rem;
  }
`;

export const GridFormFacH = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 1rem;
  overflow-y: auto;
  height: ${(props) => (props.$isModal ? "calc(100vh - 300px)" : "65vh")};
  padding-right: 10px;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(99, 96, 150, 0.7);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const DailyScheduleCardFacH = styled(Paper)`
  padding: 0.6rem 1.1rem;
  margin-bottom: 1rem;
  min-height: ${(props) => (!props.$isModal ? "170px" : "none")};
  // height: 170px;
  // max-height: 200px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(99, 96, 150, 0.7);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const DayHeaderFacH = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  gap: 2rem;
`;

export const TitleWithIconFacH = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 2;
`;

export const PresetSelectFacH = styled(FormControl)`
  width: 200px !important;
`;

export const TimeSlotsFacH = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
`;

export const TimeSlotFacH = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: #f5f5f5;
  padding: 0.3rem 1rem;
  border-radius: 8px;
  justify-content: center;
`;

export const TimeDisplayFacH = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledDialogDaySchM = styled(Dialog)`
  .MuiDialog-paper {
    width: 90%;
    max-width: 1200px;
    height: 90vh;
  }
`;

export const StyledDialogTitleDaySchM = styled(DialogTitle)`
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
`;

export const CloseButtonDaySchM = styled(IconButton)`
  padding: 0.5rem;
`;

export const EditorContainerDateSchM = styled.div`
  padding: 1rem;
`;

export const FormGroupDateSchM = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const ButtonGroupDateSchM = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
`;

export const PageContainerIndex = styled.div`
  min-height: calc(100vh - 65px);
  background: #fff;
  padding: 2rem 0;
`;

export const ContentWrapperIndex = styled.div`
  width: 90%;
  margin: 0 auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  height: 83vh;
`;

export const TabPanelIndex = styled.div`
  height: 100%;
  padding: 0.5rem 1rem;
  ${(props) =>
    !props.$visible &&
    `
    display: none;
  `}
`;

export const StyledTabsIndex = styled(Tabs)`
  background: #f8f9fa;
  font-size: 16px;
  border-bottom: 1px solid #e9ecef;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  & div:nth-of-type(2) div {
    justify-content: flex-start !important;
  }
`;

export const TabContentContainerIndex = styled.div`
  max-width: 100%;
  overflow-x: auto;
  height: 100%;
`;

export const PageWrapperPreset = styled(Container)`
  padding: 1rem 0;
`;

export const HeaderPreset = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

export const PresetCard = styled(Paper)`
  padding: 1.5rem;
  margin-bottom: 1rem;
`;

export const PresetHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

export const TitleWithIconPreset = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const TimeSlotsGridPreset = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
`;

export const TimeSlotsGridForNormalPreset = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
`;

export const TimeSlotPreset = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 0.5rem;
`;

export const TimeSlotPresetForNormal = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
  width: 100%;
`;

export const TimeDisplayPreset = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 0;
  padding: 1rem;
  border-radius: 8px;
  justify-content: space-between;
  flex-wrap: nowrap;
`;

export const TimeDisplayForNormalPreset = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 0;
  justify-content: center;
  background-color: #f5f5f5;
  padding: 1rem;
  border-radius: 8px;
`;

export const CompactTimeInputPreset = styled(TextField)`
  width: 180px;
  & input {
    font-size: 1rem;
    padding: 8px 12px;
    text-align: center;
  }
  & input:disabled {
    opacity: 0.5 !important;
    cursor: not-allowed;
  }
`;

export const PresetForm = styled(Paper)`
  padding: 1.5rem;
  margin-bottom: 2rem;
  background-color: #fafafa;
  border: 2px solid #2196f3;
`;

export const EditableTimeSlotPreset = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 48%;
  background-color: white;
  padding: 0.5rem 1rem;
  justify-content: space-between;
`;

export const PresetsList = styled.div`
  max-height: 62vh;
  overflow-y: auto;
  // max-height: calc(100vh - 150px);
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(99, 96, 150, 0.7);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 8px;
  gap: 4px;
  white-space: nowrap;
  input[type="checkbox"] {
    cursor: pointer;
    width: 16px;
    height: 16px;
    margin: 0;
  }
`;

export const StyledCheckbox = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #bdbdbd;
  border-radius: 4px;
  margin-right: 8px;
  background-color: ${(props) => (props.checked ? "#4a90e2" : "white")};
  position: relative;
  cursor: pointer;

  &:after {
    content: "";
    display: ${(props) => (props.checked ? "block" : "none")};
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    position: absolute;
    top: 2px;
    left: 6px;
    transform: rotate(45deg);
  }
`;

export const CheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
